import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './account/AuthContext';
import UserMenu from './account/UserMenu';

function UserMenuApp() {
    return (
        <BrowserRouter>
        <AuthProvider>
        <UserMenu />
        </AuthProvider>
        </BrowserRouter>
    );
}

export default UserMenuApp;
